'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

var _props3 = require('../props');

var _reactRedux = require('react-redux');

var _ActiveCar = require('./Active/ActiveCar.jsx');

var _ActiveCar2 = _interopRequireDefault(_ActiveCar);

var _PassiveCar = require('./Passive/PassiveCar.jsx');

var _PassiveCar2 = _interopRequireDefault(_PassiveCar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Email = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(Email, _Component);

  function Email() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Email);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Email.__proto__ || (0, _getPrototypeOf2.default)(Email)).call.apply(_ref, [this].concat(args))), _this), _this._renderActiveCar = function (carOption, optionNumber) {
      var components = _this.props.components;

      return _react2.default.createElement(_ActiveCar2.default, {
        components: components,
        option: carOption,
        optionNumber: optionNumber,
        key: optionNumber
      });
    }, _this._renderPassiveCar = function (carOption, optionNumber) {
      var components = _this.props.components;

      return _react2.default.createElement(_PassiveCar2.default, {
        components: components,
        option: carOption,
        optionNumber: optionNumber,
        key: optionNumber
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Email, [{
    key: '_getStyle',
    value: function _getStyle() {
      var additionalProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _props = this.props,
          backgroundColor = _props.backgroundColor,
          padding = _props.padding,
          margin = _props.margin,
          borderStyle = _props.borderStyle,
          borderWidth = _props.borderWidth,
          borderColor = _props.borderColor;


      return (0, _reactcss2.default)({
        default: {
          container: {
            backgroundColor: backgroundColor,
            padding: padding,
            margin: margin,
            borderStyle: borderStyle,
            borderWidth: borderWidth,
            borderColor: borderColor
          }
        }
      }, (0, _extends3.default)({}, this.props, additionalProps));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          components = _props2.components,
          shopOptions = _props2.shopOptions;

      var style = this._getStyle();

      var carOptions = shopOptions.options.filter(function (option) {
        return option.optionType === 'Car';
      });
      return _react2.default.createElement(
        'table',
        { style: (0, _extends3.default)({}, style.container, { width: '100%' }) },
        _react2.default.createElement(
          'tbody',
          null,
          _react2.default.createElement(
            'tr',
            null,
            _react2.default.createElement(
              'td',
              { style: { padding: '0' } },
              (carOptions.length || null) && carOptions.map(function (carOption, i) {
                return carOption.isActiveCar ? _this2._renderActiveCar(carOption, i) : _this2._renderPassiveCar(carOption, i);
              })
            )
          )
        )
      );
    }
  }]);
  return Email;
}(_react.Component), _class.propTypes = _props3.propTypes, _class.defaultProps = _props3.defaultProps, _temp2);


var mstp = function mstp(state) {
  return {
    components: state.templateApplication.templates.currentTemplate.components,
    shopOptions: state.rendering.shopOptions
  };
};

exports.default = (0, _reactRedux.connect)(mstp)(Email);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Car/Email/Email.jsx
// module id = 1502
// module chunks = 0